import React from 'react';

import {DateInput} from 'src/components/input';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Group} from '@pb/kit-component-group';
import {CustomGroupItem} from '@pb/kit-component-input-v2';

import type {CheckBoxChangeData} from 'src/typedef';

type Props = {
    editDisabled: boolean,
    expiresOn: string,
    dateInputId: string,
    today: Date,
    changeTemporaryLimitMode: (
        changeData: CheckBoxChangeData,
    ) => void,
    onExpiresOnChange: (expiresOn: string) => void,
};

export const TemporaryLimitControls = ({
    editDisabled,
    expiresOn,
    dateInputId,
    today,
    changeTemporaryLimitMode,
    onExpiresOnChange,
}: Props) => {
    if (editDisabled) {
        return null;
    }

    return (
        <Group>
            <CheckBox
                label="Make changes temporary"
                disabled={editDisabled}
                checked={!!expiresOn}
                onCheckBoxChange={
                    changeTemporaryLimitMode
                }
            />
            <CustomGroupItem label="Until">
                <DateInput
                    id={dateInputId}
                    clearable={true}
                    width={270}
                    selectedDate={expiresOn}
                    onChange={onExpiresOnChange}
                    minDate={today}
                    readonly={editDisabled}
                />
            </CustomGroupItem>
        </Group>
    );
};
